(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxAnywhereQueuesList(
    $ngBootbox, toastr, $filter, PrintQueueListService, PrintQueueListPaging, $timeout
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=tenant',
        me: '=me',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/settings/secureSettings/anywhereQueuesList/anywhereQueuesList.template.html',
      link: function(scope) {

        scope.paginationObject = new PrintQueueListPaging();
        var scrollEnd = null;
        var containerHeight = null;
        scope.searchString = '';

        (function() {
          getFirstPage();
        })();

        ////////////////////////////////////
        ////////////////////////////////////
        //////  Pagination stuff
        ////////////////////////////////////
        function getFirstPage () {
          scope.paginationObject.pagingCriteria.pageSize = 10;
          scope.paginationObject.pagingCriteria.printerTypes = ['FREEDOM'];
          scope.paginationObject.pagingCriteria.page = 0;
          scope.list = [];
          scope.loadingPage = true;
          PrintQueueListService.getPrintQueueListPaged(scope.paginationObject).then(function(pagedResponse) {
            window.scrollTo(0,0);
            scope.loadingPage = false;
            scope.totalPages = pagedResponse.page.totalPages;
            if (pagedResponse.list) {
              scope.list = pagedResponse.list;
            }
          }).catch(function(error) {
            scope.loadingPage = false;
          });
        }

        scope.textSearch = function () {
          scope.paginationObject.pagingCriteria.match = scope.searchString;
          $timeout(function () {
            getFirstPage();
          }, 0)
        }

        function getNextPage () {
          if (!scope.loadingPage && scope.totalPages > scope.paginationObject.pagingCriteria.page + 1) {
            scope.loadingPage = true;
            scope.paginationObject.pagingCriteria.page += 1;
            PrintQueueListService.getPrintQueueListPaged(scope.paginationObject).then(function(pagedResponse){
              if (pagedResponse.list) {
                scope.list = scope.list.concat(pagedResponse.list);
              }
              scope.loadingPage = false;
            }).catch(function(error) {
              scope.loadingPage = false;
            });
          }
        }

        angular.element('.item-list-nested').on('scroll', function (event) {
          scrollEnd = event.currentTarget.clientHeight + event.currentTarget.scrollTop + 1;
          containerHeight = event.currentTarget.scrollHeight;
          if (!scope.loadingPage && scope.totalPages > scope.paginationObject.pagingCriteria.page + 1) {
            if (scrollEnd > containerHeight) {
              $timeout(function() {
                getNextPage();
              }, 300)
            }
          }
        });

        scope.$on('$destroy', function() {
          angular.element('.item-list-nested').off('scroll');
        });


        ////////////////////////////////////////////
        ////////////////////////////////////////////
        // LIST MENU
        ////////////////////////////////////////////
        scope.openListMenu = function (event, queue) {
          var position = document.getElementById(event.target.id).getBoundingClientRect();
          setTimeout(function () {
            scope.closeListMenu();
            scope.listMenuContext = queue;
            scope.listMeta = {
              position: {left: position.x, top: position.y},
              parentId: event.target.id,
              type: 'queueList',
              scrollContainerId: 'QueueScrollContainer'
            }
            scope.$apply();
          }, 50)
        }

        scope.closeListMenu = function (queue, action) {
          scope.listMenuContext = null;
          scope.listMeta = null;

          switch (action) {
            case 'DELETE_QUEUE':
              scope.deleteQueue(queue);
            break;
          }
        }

        scope.deleteQueue = function(queue) {
          $ngBootbox.confirm($filter("stringular")($filter("translate")("DeletePrintQueue"), queue.info.name))
            .then(function() {
              PrintQueueListService.deletePrintQueue(queue).then(function() {
                toastr.success($filter("stringular")($filter("translate")("DeletePrintQueue"), queue.info.name));
                removeQueueFromList(queue);
              }).catch(function(error) {});
            }).catch(function(error) {});
        };

        function removeQueueFromList (queue) {
          for (var i = 0; i < scope.context.queues.length; i++) {
            if (queue.info._links.self.href === scope.context.queues[i].info._links.self.href) {
              scope.context.queues.splice(i, 1);
              break;
            }
          }
        }

        scope.createQueue = function (event) {
          scope.callback({context:
            {
              title: 'CreatePrintQueue',
              anywherePrinter: scope.context.anywherePrinter,
              event: event,
              type: 'createAnywhereQueue',
              dontUseTitle: true,
              name:  'PrintAnywhere'
            }});
        }



      }
    };
  }

  pxAnywhereQueuesList.$inject = ['$ngBootbox', 'toastr', '$filter', 'PrintQueueListService', 'PrintQueueListPaging', '$timeout'];

  angular
    .module('printix-admin')
    .directive('pxAnywhereQueuesList', pxAnywhereQueuesList);

})();
